import { fetch } from '../fetchWrapper/fetch';
import { IUpdateDetailsRequestBody, IUpdateDetailsResponse } from './types';
import { IGlobalItemData } from 'src/api/createGlobalItem/types';
import { createFormData } from 'src/helpers';
import { API_URL } from '../constants';

export const updateGlobalItemDetails = async (
  itemId: string,
  requestBody: IUpdateDetailsRequestBody,
): Promise<IGlobalItemData[]> => {
  const formData = createFormData(requestBody);
  try {
    const response = await fetch(`${API_URL}/items/${itemId}`, {
      method: 'PATCH',
      body: formData,
    });
    if (!response.ok) {
      throw new Error();
    }

    const { data }: IUpdateDetailsResponse = await response.json();
    return data;
  } catch (e) {
    throw new Error('Something went wrong whilst updating item details');
  }
};
